import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.endpointCheckDownloads = this.el.dataset.endpointCheckDownloads;
    this.endpointDownload = this.el.dataset.endpointDownload;
    this.endpointQueue = this.el.dataset.endpointQueue;
    this.endpointPrepareDownload = this.el.dataset.endpointPrepareDownload;
    this.timeoutTime = parseInt(this.el.dataset.timeout);
    this.labels = JSON.parse(this.el.dataset.labels);
    this.dom = {
      queue: this.el.querySelector('.document-library-queue'),
      ul: this.el.querySelector('.document-library-queue__list'),
      li: this.el.querySelector('.document-library-queue__li'),
      trigger: this.el.querySelector('.document-center-trigger'),
      modal: this.el.querySelector('.document-library-queue__wrapper'),
      closeModalBtn: this.el.querySelector('.btn.btn--outline'),
      notificationBar: this.el.querySelector('.notification-bar'),
      notificationBarHeading: this.el.querySelector(
        '.notification-bar__heading'
      ),
      notificationBarCopy: this.el.querySelector('.notification-bar__copy'),
      notificationBarClose: this.el.querySelector(
        '.notification-bar__close-button'
      ),
      notificationBarButtons: this.el.querySelector(
        '.notification-bar__buttons'
      )
    };

    this.downloading = window.sessionStorage.getItem(
      'documentLibraryDownloading'
    );
    this.downloading = this.downloading ? this.downloading.split(',') : '';
    this.queueStatus = {};
    if (this.el.dataset.tab !== 'true') {
      this.checkIfInterval();
    }
    this.handleResize();
  }

  addListeners() {
    window._on('resize', this.handleResize.bind(this));
    this.dom.notificationBarClose._on(
      'click',
      this.handleCloseNotification.bind(this)
    );
    this.dom.modal.addEventListener('modalopen', () => this.fetchQueue());
    this.dom.closeModalBtn.addEventListener('click', () =>
      this.dom.modal.dispatchEvent(new Event('closemodal'))
    );
  }

  checkIfInterval() {
    if (
      this.downloading &&
      this.downloading.length > 0 &&
      !this.intervalCheck
    ) {
      this.intervalCheck = setInterval(() => {
        this.handleCheckDownload();
      }, this.el.dataset.checkTime);
    } else if (!this.downloading || this.downloading.length === 0) {
      clearInterval(this.intervalCheck);
      this.intervalCheck = null;
    }
  }

  fetchQueue() {
    fetch(this.endpointQueue)
      .then(response => response.json())
      .then(data => {
        data.Queue.forEach(result => {
          const clone = this.dom.li.cloneNode(true);
          const name = clone.querySelector(
            '.document-library-queue__info-name'
          );
          const num = clone.querySelector(
            '.document-library-queue__info-claim-num'
          );
          const span = document.createElement('span');
          const error = document.createElement('span');
          error.classList.add('document-claims-library__caption--error');
          error.hidden = true;
          const downloadBtn = clone.querySelector(
            '.document-library-queue__status-btn-success button'
          );

          downloadBtn.setAttribute('tabindex', -1);

          const tryAgainBtn = clone.querySelector(
            '.document-library-queue__status-btn-failed'
          );
          error.innerText = tryAgainBtn.children[0].textContent.trim();

          const downloadLink = clone.querySelector(
            '.document-library-queue__download'
          );

          downloadLink.addEventListener('click', e =>
            this.handleDownload(e, result.Name, result.Id)
          );

          tryAgainBtn.querySelector('button').addEventListener('click', () => {
            if (this.downloading) {
              this.downloading.push(result.Id);
            } else {
              this.downloading = [result.Id];
            }
            this.checkIfInterval();
            window.sessionStorage.setItem(
              'documentLibraryDownloading',
              this.downloading
            );
            this.queueStatus[result.Id] = {
              status: 1,
              days: this.queueStatus[result.Id].days === null ? null : ''
            };
            this.displayStatus(result.Id);
            fetch(this.endpointPrepareDownload, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(result.Id)
            }).catch(error => {
              console.error('Error:', error);
            });
          });

          span.textContent = result.ClaimNumber;
          clone.setAttribute('data-id', result.Id);
          name.textContent = result.Name;
          num.appendChild(span);

          let status = result.Downloaded ? 2 : 0;
          if (this.downloading.includes(result.Id)) status = 1;
          if (result.Error) status = 0;
          this.queueStatus[result.Id] = {
            status,
            days: result.Expires ? result.RemainingDays : null
          };

          this.dom.li.remove();
          downloadLink.appendChild(error);
          this.dom.ul.appendChild(clone);
          this.displayStatus(result.Id);
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  displayStatus(id) {
    const resultItem = this.dom.ul.querySelector(`[data-id="${id}"]`);

    if (!resultItem) {
      return;
    }
    const downloadBtn = resultItem?.querySelector(
      '.document-library-queue__status-btn-success'
    );
    const downloadingBtn = resultItem?.querySelector(
      '.document-library-queue__status-btn-downloading'
    );
    const tryAgainBtn = resultItem?.querySelector(
      '.document-library-queue__status-btn-failed'
    );
    const downloadLink = resultItem?.querySelector(
      '.document-library-queue__download'
    );

    switch (this.queueStatus[id].status) {
    case 0:
      downloadBtn.hidden = true;
      downloadingBtn.hidden = true;
      tryAgainBtn.hidden = false;
      downloadLink.style = 'display: none';
      break;
    case 1:
      downloadBtn.hidden = true;
      downloadingBtn.hidden = false;
      tryAgainBtn.hidden = true;
      downloadLink.style = 'display: none';
      break;
    default:
      downloadBtn.hidden = false;
      downloadingBtn.hidden = true;
      tryAgainBtn.hidden = true;
      downloadLink.style = '';

      const caption = downloadBtn.querySelector(
        '.document-claims-library__caption'
      );

      if (this.queueStatus[id].days === null) {
        caption?.remove();
      } else {
        caption.textContent = caption.innerText.replace(
          '{0}',
          this.queueStatus[id].days
        );
      }
      break;
    }
  }

  handleResize() {
    this.dom.notificationBar.setAttribute(
      'style',
      `--button-height: ${this.dom.notificationBarButtons.offsetHeight}px`
    );
  }

  handleCheckDownload() {
    fetch(this.endpointCheckDownloads, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.downloading)
    })
      .then(response => response.json())
      .then(data => {
        const downloaded = data.Downloaded.filter(id =>
          this.downloading.includes(id)
        );

        const errored = data.Errored?.filter(id =>
          this.downloading.includes(id)
        );
        if (downloaded.length > 0 || errored.length > 0) {
          this.downloading = this.downloading.filter(
            id => !downloaded.includes(id) && !errored.includes(id)
          );

          window.sessionStorage.setItem(
            'documentLibraryDownloading',
            this.downloading
          );

          this.checkIfInterval();

          this.downloadedFilesLength = data.DownloadedFiles;
          this.downloadedQueueLength = data.QueueLength;

          if (downloaded.length > 0 && errored.length === 0) {
            this.documentName = data.DocumentName;
            this.erroredNotification = false;
            this.handleDisplayNotification();

            downloaded.forEach(download => {
              if (this.queueStatus[download]) {
                this.queueStatus[download] = {
                  status: 2,
                  days:
                    this.queueStatus[download].days === null
                      ? null
                      : data.DefaultDays
                };
                this.displayStatus(download);
              }
            });
          }

          if (errored.length > 0) {
            this.erroredNotification = true;
            this.handleDisplayNotification();
            errored.forEach(error => {
              if (this.queueStatus[error]) {
                this.queueStatus[error] = {
                  status: 0,
                  days:
                    this.queueStatus[error].days === null
                      ? null
                      : data.DefaultDays
                };
              } else {
                this.queueStatus[error] = {
                  status: 0,
                  days: null
                };
                this.displayStatus(error);
              }
            });
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  handleDisplayNotification() {
    if (this.erroredNotification) {
      this.dom.notificationBarHeading.innerText =
        this.downloadedQueueLength > 1
          ? this.labels.notificationsErrorHeading
            .replace('{0}', this.downloadedFilesLength)
            .replace('{1}', this.downloadedQueueLength)
          : this.labels.notificationErrorHeading.replace(
            '{0}',
            this.documentName
          );
      this.dom.notificationBarCopy.innerText =
        this.downloadedQueueLength > 1
          ? this.labels.notificationErrorCopy
          : this.labels.notificationsErrorCopy;
    } else {
      this.dom.notificationBarHeading.innerText =
        this.downloadedQueueLength > 1
          ? this.labels.notificationsReadyHeading
            .replace('{0}', this.downloadedFilesLength)
            .replace('{1}', this.downloadedQueueLength)
          : this.labels.notificationReadyHeading.replace(
            '{0}',
            this.documentName
          );
      this.dom.notificationBarCopy.innerText =
        this.downloadedQueueLength > 1
          ? this.labels.notificationReadyCopy.replace('{0}', this.documentName)
          : this.labels.notificationsReadyCopy.replace(
            '{0}',
            this.documentName
          );
    }

    if (this.timeoutTime > 0) {
      this.timeout = setTimeout(() => {
        this.handleCloseNotification();
      }, this.timeoutTime);
    }
    this.dom.notificationBar.classList.add('notification-bar--show');
  }

  handleCloseNotification() {
    clearTimeout(this.timeout);
    this.dom.notificationBar.classList.remove('notification-bar--show');
  }

  handleDownload(e, name, id) {
    e.preventDefault();
    const anchor = document.createElement('a');
    anchor.classList.add('download-link-hidden');
    const req = new XMLHttpRequest();
    const target = e.target;
    target.setAttribute('disabled', 'true');
    if (target.children[0]) {
      target.children[0].hidden = true;
    }

    req.responseType = 'blob';
    req.open('get', `${this.endpointDownload}?id=${id}`, true);
    req.send();

    req.onreadystatechange = e => {
      const filename = req
        .getResponseHeader('content-disposition')
        ?.split('filename=');
      const request = e.target;
      const responseType = request.getResponseHeader('content-type');
      const isFile = responseType === 'application/pdf';

      if (request.readyState === 4 && request.status === 200 && isFile) {
        const fileUrl = window.URL.createObjectURL(request.response);
        anchor.href = fileUrl;
        anchor.download = filename
          ? filename[1].replaceAll('"', '')
          : name || 'file';
        anchor.target = '_blank';
        anchor.click();
        target.removeAttribute('disabled');
      } else if (request.readyState === 4) {
        target.removeAttribute('disabled');
        target.children[0].hidden = false;
      }
    };

    req.onprogress = e => {
      const percentage = Math.round(e.loaded / e.total / 100);

      if (percentage > 99) {
        anchor.remove();
        target.removeAttr('disabled');
      }
    };
  }
}

export default Module;
